import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Frame } from '../components/shell/AppShell';
import PageHeader from '../components/shell/PageHeader';
import { MemberCardFace } from '../components/MemberCard';
import gateArt from '../assets/bg/gate-login.webp';
import { moreFor } from '../lib/navigation';

/**
 * The member's own card, a child of More: More stays lit in the navigation
 * and Back returns there. Shown on the gate artwork (the manifest's
 * "membership presentation"), darkened so the card, not the door, is what
 * the eye lands on.
 */
const Membership = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <Frame user={user} background={gateArt} scrim={0.6} activeKey="more">
      <div data-testid="membership-page">
        <PageHeader
          title="Membership"
          subtitle="Private member credential"
          onBack={() => navigate(moreFor(user))}
        />
        {/* Centred on the screen, which puts the card over the door's own
            crest -- one seal on screen, not two. */}
        <div
          className="mx-auto flex max-w-sm flex-col justify-center px-4 pb-6"
          style={{ minHeight: 'calc(100dvh - 64px - 96px - env(safe-area-inset-bottom) - env(safe-area-inset-top))' }}
        >
          <MemberCardFace user={user} />
        </div>
      </div>
    </Frame>
  );
};

export default Membership;
